import { Toast, Dialog } from 'vant';
import wx from 'jweixin-1.6.0';
import comment from "../../util/comment"

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    data() {
        return {
            dhInfoList: [],
            test:"0"
        };
    },

    created() {
        that = this;
        this.getDhGoodsInfoList();
        // setInterval(() => { //每5秒刷新一次图表
        //     this.getDhGoodsInfoList();
        // }, 5000);
    },
    
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },
    mounted() {
        timer = setInterval(() => { //每5秒刷新一次图表
            this.getDhGoodsInfoList();
        }, 5000);

    },
    unmounted(){
        clearInterval(timer);
    },
    methods: {
        getDhGoodsInfoList() {
            console.log(this.test);
            console.log(this.$route.query.memberId);
            this.$api.getDhGoodsInfoList({
                params: {
                    memberId: this.$route.query.memberId + '',
                },
                success: function (res) {
                    console.log("resres", res);
                    that.dhInfoList = res.data
                }
            })
        },

        jumpInfo(id) {
            this.$router.push({
                path: '/convertDetail',
                query: {
                    goodsId: id,
                    memberId: this.$route.query.memberId
                }
            })
        },

        goUrl() {
            this.$router.push({
                path: '/records',
                query: {
                    memberId: this.$route.query.memberId
                }
            })
        }


    }
};
